import { render, staticRenderFns } from "./SplitSelector.vue?vue&type=template&id=3495222a&scoped=true"
import script from "./SplitSelector.vue?vue&type=script&lang=js"
export * from "./SplitSelector.vue?vue&type=script&lang=js"
import style0 from "./SplitSelector.vue?vue&type=style&index=0&id=3495222a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3495222a",
  null
  
)

export default component.exports